import { useEffect } from "react";

const ChatWidget = () => {
  useEffect(() => {
    if (document.getElementById("chat-widget-script")) return;

    const name = sessionStorage.getItem("name");
    const email = sessionStorage.getItem("emailID");
    const mobile = sessionStorage.getItem("mobileNo");

    window.ChatUser = {
      name: name || "Guest",
      email: email || "",
      mobile: mobile || "",
    };

    window.chatSystem = {
      widgetKey: "chat_69b807859aa3b65ce75b3a7b4d3ee5777b012d57b4256",
      baseUrl: "https://robot.ayyun.co.in",
    };

    const script = document.createElement("script");
    script.src = "https://robot.ayyun.co.in/widget.js";
    script.async = true;
    script.id = "chat-widget-script";

    script.onerror = () => {
      console.log("Chat widget failed to load");
    };

    document.body.appendChild(script);
  }, []);

  return null;
};

export default ChatWidget;
